import React, { Fragment } from 'react';
import AffiliationForm from 'v2/components/Pages/Product/Edit/Forms/Affiliation';
import Content from 'v2/components/Shared/Content';

import { useEditProduct } from '../../context';
import AffiliateInstructionsForm from '../../Forms/AffiliateInstructions';
import MaterialsForm from '../../Forms/Materials';
import RecruiterForm from '../../Forms/Recruiter';

function Affiliates() {
  const {
    affiliation,
    saveAffiliation,
    isLoadingAffiliation,
    saveAffiliateInstructions,
    isLoadingAffiliateInstructions,
    affiliateInstructions,
    saveRecruiter,
    recruiter,
    isLoadingRecruiter,
    saveMaterials,
    materials,
    isLoadingMaterials,
  } = useEditProduct();

  return (
    <Fragment>
      <Content>
        {[
          {
            id: 'payments',
            title: 'Afiliação',
            anchor: 'Afiliação',
            validations: null,
            submit: saveAffiliation,
            defaultValues: affiliation,
            isLoading: isLoadingAffiliation,
            content: (cProps: any) => <AffiliationForm {...cProps} />,
          },
          {
            id: 'instructions',
            title: 'Instruções e Termos',
            anchor: 'Instruções e Termos',
            validations: null,
            submit: saveAffiliateInstructions,
            defaultValues: affiliateInstructions,
            isLoading: isLoadingAffiliateInstructions,
            content: (cProps: any) => <AffiliateInstructionsForm {...cProps} />,
          },
          {
            id: 'recruiter',
            title: 'Recrutamento',
            anchor: 'Recrutamento',
            validations: null,
            submit: saveRecruiter,
            defaultValues: recruiter,
            isLoading: isLoadingRecruiter,
            content: (cProps: any) => <RecruiterForm {...cProps} />,
          },
          {
            id: 'promotional',
            title: 'Material de Divulgação',
            anchor: 'Material de Divulgação',
            validations: null,
            submit: saveMaterials,
            defaultValues: materials,
            isLoading: isLoadingMaterials,
            content: (cProps: any) => <MaterialsForm {...cProps} />,
          },
        ]}
      </Content>
    </Fragment>
  );
}

export default Affiliates;
